import reduceOpacity from '../../common/utils/reduce-opacity';

const INITIAL_OPACITY = 1;

const mediumEmphasis = (params) => {
  const { targetColor, backgroundColor, surfaceColor } = params;
  return reduceOpacity({
    targetColor,
    backgroundColor,
    surfaceColor,
    opacity: INITIAL_OPACITY,
    condition: (ratio) => ratio < 4.5,
    fallback: {
      rule: 'text.mediumEmphasis',
      params,
    },
  });
};

export default mediumEmphasis;
